<script setup lang="ts">
    import { getSlugForContext } from '~/utils/CenshareClient/slugMap';
    import { buildProductDetailPath, useRequiredProductSectionPath } from '#imports';
    import { SplideSlide } from '@splidejs/vue-splide';

    const props = defineProps<{
        product: ProductItemGroup;
    }>();
    const { urlSegment, lang, country } = useLanguage();
    const { t } = useI18n();
    const productSectionPath = useRequiredProductSectionPath();

    const fachkreisCrossselling = ref(props.product?.relations?.crossSellings);

    const getCrossSellingLink = (crossSellingItem: ProductItemGroup) => {
        const slug =
            getSlugForContext(crossSellingItem.slugs, country.value, lang.value) ||
            slugify(crossSellingItem.nameLocalized?.[lang.value] || crossSellingItem.name || 'INVALID');

        return buildProductDetailPath(urlSegment.value, productSectionPath.value, slug);
    };

    const sliderOptions = computed(() => {
        return {
            perPage: 3,
            rewind: true,
            rewindByDrag: true,
            gap: '1rem',
            drag: fachkreisCrossselling?.value?.length > 3,
            arrows: fachkreisCrossselling.value && fachkreisCrossselling?.value?.length > 3,
            breakpoints: {
                1024: {
                    perPage: 2,
                    arrows: fachkreisCrossselling.value && fachkreisCrossselling?.value?.length > 2
                },
                640: {
                    perPage: 1,
                    arrows: fachkreisCrossselling.value && fachkreisCrossselling?.value?.length > 1
                }
            }
        };
    });
</script>
<template>
    <div
        v-if="props.product !== null"
        class="crossselling-container"
    >
        <h2 class="title">{{ t('product.crosssellingFachkreis') }}</h2>
        <LazySliderComponent :options="sliderOptions">
            <template #slides>
                <SplideSlide
                    v-for="crossSellingItem in fachkreisCrossselling?.slice(0, 10)"
                    :key="crossSellingItem"
                    class="slide"
                >
                    <FachkreisProductCard
                        :name="crossSellingItem.nameLocalized?.[lang] || crossSellingItem.name || 'INVALID'"
                        :image-id="crossSellingItem.mainPicture?.[0]?.id || null"
                        :link-to="getCrossSellingLink(crossSellingItem)"
                    />
                </SplideSlide>
            </template>
        </LazySliderComponent>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/detail-page/crossselling-slider.scss';
</style>
